<template>
    <el-dialog title="Penalizare Deviz" :visible.sync="visible"  :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true">

        <div v-loading="loading">
            <el-form :model="form" ref="formPenalizare" label-position="top">

                <el-alert v-if="errorMsg" :title="errorMsg" type="error" show-icon style="margin-bottom: 15px;"
                    :closable="false">
                </el-alert>

                <el-alert v-if="isEditMode"
                    title="Acest deviz a fost deja penalizat. Modificarea va suprascrie datele anterioare."
                    type="warning" show-icon style="margin-bottom: 15px;" :closable="false">
                </el-alert>

                <el-form-item label="Selectati motivele (din lista predefinita):">
                    <div v-if="motiveOptions.length === 0" class="text-muted">
                        Nu exista motive predefinite in setari.
                    </div>
                    <el-checkbox-group v-model="form.selectedMotive"
                        style="display:flex; flex-direction:column; gap:5px;">
                        <el-checkbox v-for="(motiv, index) in motiveOptions" :key="index" :label="motiv">
                            {{ motiv }}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item label="Alt motiv / Observatii">
                    <el-input type="textarea" :rows="3" placeholder="Scrieti aici motivul daca nu se afla in lista..."
                        v-model="form.customMotiv">
                    </el-input>
                </el-form-item>

            </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="visible = false" size="small">Anuleaza</el-button>
            <el-button type="danger" @click="save" size="small" :loading="saving">
                {{ isEditMode ? 'Actualizeaza' : 'Penalizeaza' }}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import BasePage from "@/pages/Admin/BasePage";

export default {
    name: "PenalizareDialog",
    extends: BasePage,
    data() {
        return {
            visible: false,
            loading: false,
            saving: false,
            idDeviz: null,
            isEditMode: false,
            motiveOptions: [],
            errorMsg: '',
            form: {
                selectedMotive: [],
                customMotiv: ''
            }
        };
    },
    methods: {
        async open(row) {
            this.idDeviz = row.Id;
            this.visible = true;
            this.resetForm();

            await this.get_motive();

            if (row.Penalizat == 1 && row.MotivPenalizare) {
                this.isEditMode = true;
                this.prefillData(row.MotivPenalizare);
            }
        },

        resetForm() {
            this.form.selectedMotive = [];
            this.form.customMotiv = '';
            this.errorMsg = '';
            this.isEditMode = false;
        },

        prefillData(savedString) {
            const parts = savedString.split(', ');
            let customParts = [];

            parts.forEach(part => {
                part = part.trim();
                if (this.motiveOptions.includes(part)) {
                    this.form.selectedMotive.push(part);
                } else {
                    if (part !== "") {
                        customParts.push(part);
                    }
                }
            });

            if (customParts.length > 0) {
                this.form.customMotiv = customParts.join(', ');
            }
        },

        async get_motive() {
            if (this.motiveOptions.length > 0) return;

            this.loading = true;
            try {
                let response = await this.post("admin/setari/get_motive_penalizare");
                if (response.motive) {
                    this.motiveOptions = response.motive;
                }
            } catch (e) {
                console.error(e);
            } finally {
                this.loading = false;
            }
        },

        async save() {
            this.errorMsg = '';

            const hasSelection = this.form.selectedMotive.length > 0;
            const hasCustomText = this.form.customMotiv && this.form.customMotiv.trim().length > 0;

            if (!hasSelection && !hasCustomText) {
                this.errorMsg = "Trebuie sa selectati un motiv din lista sau sa scrieti unul manual!";
                return;
            }

            this.saving = true;
            try {
                let payload = {
                    IdDeviz: this.idDeviz,
                    MotiveSelectate: this.form.selectedMotive,
                    MotivCustom: this.form.customMotiv
                };

                let response = await this.post("receptie/devize/save_penalizare_deviz", payload);

                if (response.Success) {
                    this.$message.success("Devizul a fost penalizat cu succes!");
                    this.visible = false;
                    this.$emit('saved');
                } else {
                    this.$message.error(response.Message || "Eroare la salvare.");
                }

            } catch (e) {
                console.error(e);
                this.$message.error("A aparut o eroare de comunicare.");
            } finally {
                this.saving = false;
            }
        }
    }
};
</script>

<style scoped>
.text-muted {
    color: #999;
    font-style: italic;
    font-size: 12px;
}
</style>